import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import jquery from 'jquery';
import 'summernote/dist/summernote-lite.min.js';
import 'summernote/dist/summernote-lite.min.css';
import 'summernote/dist/lang/summernote-ko-KR';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getMAGAF020, postMAGAF020, putMAGAF020 } from '../../../services/Api';
import CheckGroup from '../../../shared/components/CheckGroup';
import SideMenu from '../../../shared/components/SideMenu';

import { decodeHTML } from 'entities';
import { MENU_CENTER, MESSAGE } from '../../../shared/constants/app';
import PopupMAGAF020 from './popupMAGAF020';
import DatePicker from 'react-datepicker';

const MAGAF020 = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isPreview, setIsPreview] = useState(false);
    const [dataPopup, setDataPopup] = useState({});

    const startDateRef = useRef();
    const endDateRef = useRef();

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const editorRef = useRef(null);

    useEffect(() => {
        jquery(editorRef.current).summernote({
            height: 300,
            lang: 'ko-KR',
            placeholder: '내용을 입력하세요...',
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture', 'video']],
                ['view', ['codeview']],
            ],
        });
    }, []);

    const [data, setData] = useState({
        title: '',
        contents: '',
        gubun: '01',
        target: 'A',
    });

    const [checkedValues, setCheckedValues] = useState({
        notice: 'N',
        contentView: 'N',
        mainYn: 'N',
        myPageYn: 'N',
    });

    const handleDateChange = (date, name) => {
        if (name === 'startDate') {
            if (endDate && date > endDate) {
                alert('시작 날짜는 종료 날짜보다 늦을 수 없습니다.');
                return;
            }
            setStartDate(date);
        } else if (name === 'endDate') {
            if (startDate && date < startDate) {
                alert('종료 날짜는 시작 날짜보다 빠를 수 없습니다.');
                return;
            }
            setEndDate(date);
        }
    };

    useEffect(() => {
        if (id) {
            getMAGAF020(id)
                .then(({ data }) => {
                    setData({
                        title: data.title || '',
                        contents: decodeHTML(data.contents) || '',
                        gubun: data.gubun || '',
                        target: data.target || '',
                        ord: data.ord || '',
                    });
                    setCheckedValues({
                        notice: data.notice ? data.notice : 'N',
                        contentView: data.contentView ? data.contentView : 'N',
                        mainYn: data.mainYn ? data.mainYn : 'N',
                        myPageYn: data.myPageYn ? data.myPageYn : 'N',
                    });
                    if (data.startDate) {
                        setStartDate(new Date(data.startDate));
                    }
                    if (data.endDate) {
                        setEndDate(new Date(data.endDate));
                    }
                    if (editorRef.current) {
                        jquery(editorRef.current).summernote('code', data.contents);
                    }
                })
                .catch((error) => console.log(error));
        }
    }, [id]);

    const getOptions = (name) => {
        const options = {
            notice: [{ id: 'notice', label: '상단공지설정', value: 'Y' }],
            contentView: [{ id: 'contentView', label: '내용같이보기설정', value: 'Y' }],
            mainYn: [{ id: 'mainYn', label: '메인페이지', value: 'Y' }],
            myPageYn: [{ id: 'myPageYn', label: '마이페이지', value: 'Y' }],
        };
        return options[name];
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setCheckedValues((prevValues) => ({
            ...prevValues,
            [name]: checked ? 'Y' : 'N',
        }));
    };

    const handleSave = () => {
        if (!data.title.trim()) {
            window.alert('제목을 입력해 주세요.');
            return;
        }

        const content = jquery(editorRef.current).summernote('code').trim();
        if (!content || content === '<p><br></p>') {
            window.alert('내용을 입력해 주세요.');
            return;
        }

        const isConfirmed = window.confirm('등록/수정하시겠습니까?');
        if (isConfirmed) {
            if (id) {
                putMAGAF020({
                    seq: id,
                    gubun: data.gubun,
                    target: data.target,
                    notice: checkedValues.notice,
                    contentView: checkedValues.contentView,
                    title: data?.title || '',
                    contents: jquery(editorRef.current).summernote('code'),
                    ftsContents: jquery(editorRef.current)
                        .summernote('code')
                        .replace(/<\/p>/gi, '\n')
                        .replace(/<br\/?>/gi, '\n')
                        .replace(/<\/?[^>]+(>|$)/g, ''),
                    ord: data.ord,
                    mainYn: checkedValues.mainYn,
                    myPageYn: checkedValues.myPageYn,
                    startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
                    endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : null,
                })
                    .then(() => {
                        window.alert('등록/수정되었습니다.');
                        navigate('/magaf010');
                    })
                    .catch((error) => {
                        console.log(error);
                        window.alert(MESSAGE.notify.updateError);
                    });
            } else {
                postMAGAF020({
                    gubun: data.gubun,
                    target: data.target,
                    notice: checkedValues.notice,
                    contentView: checkedValues.contentView,
                    title: data?.title || '',
                    contents: jquery(editorRef.current).summernote('code'),
                    ftsContents: jquery(editorRef.current)
                        .summernote('code')
                        .replace(/<\/p>/gi, '\n')
                        .replace(/<br\/?>/gi, '\n')
                        .replace(/<\/?[^>]+(>|$)/g, ''),
                    addDate: moment().format('YYYY-MM-DDTHH:mm:ss.SSS'),
                    mainYn: checkedValues.mainYn,
                    myPageYn: checkedValues.myPageYn,
                    startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
                    endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : null,
                })
                    .then(() => {
                        window.alert('등록/수정되었습니다.');
                        navigate('/magaf010');
                    })
                    .catch((error) => {
                        console.log(error);
                        window.alert(MESSAGE.notify.createError);
                    });
            }
        }
    };

    const closePreview = () => {
        setIsPreview(false);
    };

    const openPreview = () => {
        setDataPopup({
            ...data,
            contents: jquery(editorRef.current).summernote('code'),
        });
        setIsPreview(true);
    };

    return (
        <>
            <div className="container dental-magazine">
                <div className="wrap">
                    <SideMenu menu={MENU_CENTER} />
                    <div className="list-of-dental-journals-content content-right customer-center-notice">
                        {!id ? <h1 className="title">공지/소식 등록</h1> : <h1 className="title">공지/소식 수정</h1>}
                        <div id="dental-magazine-content-list">
                            <table className="table-gray">
                                <tbody>
                                    <tr>
                                        <th>
                                            <span>구분</span>
                                        </th>
                                        <td colSpan={3}>
                                            <div className="select-box">
                                                <select name="gubun" value={data.gubun} onChange={handleChange}>
                                                    <option value="01">공지</option>
                                                    <option value="02">소식</option>
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span>대상</span>
                                        </th>
                                        <td colSpan={3}>
                                            <div className="select-box align-items-center">
                                                <select name="target" value={data.target} onChange={handleChange}>
                                                    <option value="A">전체회원</option>
                                                    <option value="C">치과회원</option>
                                                    <option value="P">개인회원</option>
                                                </select>
                                                <span>
                                                    * 대상이 치과회원 또는 개인회원으로 선택된 경우는 해당 회원 로그인시
                                                    내용이 공지됩니다.
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span className="required">제목</span>
                                        </th>
                                        <td>
                                            <input
                                                type="text"
                                                placeholder=""
                                                name="title"
                                                onChange={handleChange}
                                                value={data?.title}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span>상단공지설정</span>
                                        </th>
                                        <td>
                                            <CheckGroup
                                                name="notice"
                                                options={getOptions('notice')}
                                                checkedValues={checkedValues.notice}
                                                onChange={handleCheckboxChange}
                                                type="checkbox"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span>내용같이보기</span>
                                        </th>
                                        <td>
                                            <CheckGroup
                                                name="contentView"
                                                options={getOptions('contentView')}
                                                checkedValues={checkedValues.contentView}
                                                onChange={handleCheckboxChange}
                                                type="checkbox"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span>게재 위치</span>
                                        </th>
                                        <td style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <CheckGroup
                                                name="mainYn"
                                                options={getOptions('mainYn')}
                                                checkedValues={checkedValues.mainYn}
                                                onChange={handleCheckboxChange}
                                                type="checkbox"
                                            />
                                            <CheckGroup
                                                name="myPageYn"
                                                options={getOptions('myPageYn')}
                                                checkedValues={checkedValues.myPageYn}
                                                onChange={handleCheckboxChange}
                                                type="checkbox"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span>공지 기간</span>
                                        </th>
                                        <td style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div style={{ position: 'relative' }}>
                                                <DatePicker
                                                    ref={startDateRef}
                                                    onChange={(date) => handleDateChange(date, 'startDate')}
                                                    locale={'ko'}
                                                    placeholderText={'YYYY/MM/DD'}
                                                    dateFormat={'yyyy/MM/dd'}
                                                    selected={startDate}
                                                    maxDate={endDate || null}
                                                />
                                                <i
                                                    className="icon icon-date"
                                                    id="start-date-icon"
                                                    style={{ top: '8px' }}
                                                    onClick={() => startDateRef.current.setFocus()}
                                                />
                                            </div>
                                            <span>~</span>
                                            <div style={{ position: 'relative' }}>
                                                <DatePicker
                                                    ref={endDateRef}
                                                    onChange={(date) => handleDateChange(date, 'endDate')}
                                                    locale={'ko'}
                                                    placeholderText={'YYYY/MM/DD'}
                                                    dateFormat={'yyyy/MM/dd'}
                                                    selected={endDate}
                                                    minDate={startDate || null}
                                                />
                                                <i
                                                    className="icon icon-date"
                                                    id="end-date-icon"
                                                    style={{ top: '8px' }}
                                                    onClick={() => endDateRef.current.setFocus()}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span className="required">내용</span>
                                        </th>
                                        <td colSpan={3}>
                                            <div style={{ height: '300px' }} ref={editorRef}></div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="bottom-content">
                            <Link to="/magaf010" className="button-back-to-list">
                                목록
                            </Link>
                            <div className="flex gap-10">
                                <button
                                    className="button-back-to-list"
                                    style={{ marginRight: '10px', width: '100px' }}
                                    onClick={openPreview}
                                >
                                    미리보기
                                </button>
                                <Link onClick={handleSave} className="button-save">
                                    등록/수정
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isPreview && <PopupMAGAF020 closePreview={closePreview} dataPopup={dataPopup} />}
        </>
    );
};

export default MAGAF020;